<template>
  <div class="container bg-gray-neutral-100 relative overflow-hidden">
    <div class="flex flex-wrap -mx-grap items-center flex-col mb-4">
      <div class="w-12/12 md:w-4/12 text-center">
        <h2 class="text-blue-dark font-bold mt-4 mb-0">{{ content.title }}</h2>
      </div>
      <div class="w-12/12 md:w-5/12 text-center">
        <p class="text-blue-dark mt-1 mb-1">{{ content.sub }}</p>
        <span
          @click="open = !open"
          class="text-blue-default text-xl font-bold no-underline border-b-2 border-blue-default mt-1/2 hover:no-underline cursor-pointer"
          >{{ content.link.text }}</span
        >
      </div>
    </div>
    <div class="flex flex-wrap px-1 md:px-5 justify-between mb-4">
      <div
        class="w-12/12 md:w-auto"
        v-for="(feature, index) in content.features"
        :key="index"
      >
        <p class="font-semibold text-blue-dark text-22">
          {{ feature.title }}
        </p>
        <ul class="list-disc list-inside  min-w-[250px]">
          <li
            class="text-22 font-normal text-blue-dark leading-8"
            v-for="(item, i) in feature.list"
            :key="i"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
    <circles></circles>
    <circles class="second" ></circles>
    <LicensePopup v-if="open" :content="content" @close="open = !open" />
  </div>
</template>
<style lang="scss" scoped>
.container {
  max-width: 1290px;
  margin: 120px auto;
}
svg {
  transform: translate(-50%, -50%);
}
svg ~ svg {
  transform: translate(272%, 162%);
}
@media (max-width: 768px) {
  svg {
    display: none;
  }
}
</style>
<script>
import LicensePopup from "./LicensePopup.vue";
import Circles from "../../../utils/icons/circles.vue";
export default {
  components: {
    LicensePopup,
    Circles,
  },
  props: {
    content: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>
